import { useMutation } from "@apollo/client";

import { MapEditorObservationPanelObservationFragment } from "./fragments.generated";
import { MapEditorObservationPanel_ObservationCloneDocument } from "./mutations.generated";

export function useCloneObservationMutation() {
    const [mutate, result] = useMutation(MapEditorObservationPanel_ObservationCloneDocument);

    const cloneObservation = (observationId: string) => mutate({ variables: { input: { observationId } } });

    return [cloneObservation, result] as const;
}

export type CloneObservationResult = MapEditorObservationPanelObservationFragment | undefined;
